import { useQuery } from '@tanstack/react-query'

import { CAR_QUERY_KEYS } from '@/entities/car/lib'

import { getCarModelList } from '../request/carApis'

import type { ICarModel } from '@/entities/car/model'
const useCarModelListQuery = (brandId: number | null) => {
  return useQuery<ICarModel[]>({
    queryKey: CAR_QUERY_KEYS.CAR_MODEL.list(brandId!),
    queryFn: () => getCarModelList(brandId!),
    enabled: !!brandId,
    throwOnError: false,
  })
}

export default useCarModelListQuery
